import BreadCrumb from "../../Common/BreadCrumb";
import React, { useRef } from "react";
import {
  Card,
  Container,
  Col,
  CardBody,
  Row,
  Form,
  Button,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import SelectField from "../../Utils/SelectField";
import { LabelText } from "../../Utils/Input";
import InputField from "../../Utils/InputField";
import { Formik } from "formik";
import { importInitialValues } from "./constants/initialValues";
import { validationSchemaForImport } from "./constants/validationSchema";
import {
  csvFormData,
  getFile,
  handleDownloadClick,
} from "./constants/GrantsAndRecurringFunctions";
import { useState } from "react";
import { Loader } from "../../Utils/Loader";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";

export const ImportData = ({ importModalOpen, setImportModalOpen }) => {
  const [validationTriggered, setValidationTriggered] = useState(false);
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Modal
      backdrop="static"
      centered={true}
      isOpen={importModalOpen}
      style={{ "--vz-modal-width": "650px" }}
    >
      <ModalHeader
        // toggle={() => setImportModalOpen(false)}
        className="fs-3 fw-bold justify-content-center rv-text-color pt-4"
      >
        {"Import Data"}
        <button
          type="button"
          className="close-button-currency position-absolute top-0 end-0 mt-1 me-3 border-0 bg-transparent fs-3"
          onClick={() => setImportModalOpen(false)}
        >
          &times;
        </button>
      </ModalHeader>
      <Formik
        initialValues={importInitialValues}
        validationSchema={validationSchemaForImport}
        onSubmit={() => {
          csvFormData(file, setLoading, navigate, dispatch);
        }}
      >
        {({ handleBlur, values, touched, handleSubmit, handleChange }) => (
          <Form onSubmit={handleSubmit} className="needs-validation">
            <ModalBody className="justify-content-start p-4 w-100 pb-0">
              <p className="fs-5">
                <span
                  className="rv-text-primary-color fw-semibold"
                  onClick={handleDownloadClick}
                >
                  Download a sample file
                </span>{" "}
                <span className="rv-text-color fw-semibold">
                  {" "}
                  of how the CSV file should be formatted for import.
                </span>
              </p>
              <LabelText
                htmlFor={"csvFile"}
                classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                displayText={
                  "Select your CSV File (File size maximum limit is 10mb, Allowed extensions : CSV)"
                }
              />
              <Col>
                <InputField
                  name={"csvFile"}
                  accept={".csv"}
                  value={values.csvFile}
                  className={"mt-2 "}
                  handleBlur={handleBlur}
                  type={"file"}
                  handleChange={getFile(
                    setFile,
                    handleChange,
                    setValidationTriggered
                  )}
                  invalid={touched.csvFile && !validationTriggered}
                />
                {touched.csvFile && !validationTriggered ? (
                  <FormFeedback type="invalid">
                    {file
                      ? "File size exceeds the limit (10MB)."
                      : "Please select a file"}
                  </FormFeedback>
                ) : null}
              </Col>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center align-items-center p-4">
              <div className="d-flex flex-row gap-3">
                <Button
                  onClick={() => {
                    setImportModalOpen(false);
                  }}
                  className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                >
                  <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-1" />
                  <span className="ps-3 px-2 ms-2 me-1 modal-btn fw-bold">
                    Cancel
                  </span>
                </Button>
                <Button
                  className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                  type="submit"
                >
                  <i className="ri-upload-line label-icon align-middle fs-16 me-1"></i>
                  <span className="ps-3 px-2 ms-2 me-1 modal-btn fw-bold">
                    Upload
                  </span>
                </Button>
              </div>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
